import React from 'react';
import StoreButtons from './StoreButtons';
import './Hero.css';

const Hero = () => {
  const scrollToDownload = () => {
    const element = document.getElementById('download');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1>
              Turn Cards into <span className="highlight">Leads Instantly</span>
            </h1>
            <p className="hero-subtitle">
              Scan2Card makes lead collection effortless. With just a scan of any physical 
              business card or QR code, automatically extract all contact details and create 
              digital entries.
            </p>
            
            <div className="hero-features">
              <div className="feature-item">
                <span className="checkmark">✓</span>
                <span>Scan physical business cards instantly</span>
              </div>
              <div className="feature-item">
                <span className="checkmark">✓</span>
                <span>Digitize QR-based digital cards</span>
              </div>
              <div className="feature-item">
                <span className="checkmark">✓</span>
                <span>Team collaboration & sync</span>
              </div>
            </div>

            <StoreButtons />
          </div>
          
          <div className="hero-phone">
            <div className="phone-frame">
              <div className="phone-screen">
                <img src="/assets/hero-phone.png" alt="Scan2Card App" className="phone-mockup" />
              </div>
              <div className="phone-notch"></div>
              <div className="phone-home-indicator"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;